import { Component, Input } from '@angular/core';

@Component({
  selector: 'cigna-coverage-status',
  templateUrl: './coverage-status.component.html',
  styleUrls: ['./coverage-status.component.scss'],
})
export class CoverageStatusComponent {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() inactive: boolean;
  @Input() status: string;
  @Input() size: 'small' | 'medium' | 'large' = 'small';

  parseCoverageStatus(cs: string): string {
    let status = '';

    if (cs === 'A') {
      status = 'Active';
    } else if (cs === 'I' || cs === 'T') {
      status = 'Inactive';
    } else if (cs === 'F') {
      status = 'Medicare Advantage';
    } else if (cs === 'PY') {
      status = 'Payer Solutions';
    } else if (cs === 'GWFC') {
      status = '(Former) Great West';
    } else if (cs === 'SP' || cs === 'SAR') {
      status = 'Shared Administration/Alliance Patient';
    } else if (cs === 'D' || cs === 'N') {
      status = '';
    } else {
      status = cs;
    }

    return status;
  }
}
